import { InfoComp } from 'components/InfoComp';
import { ButtonIconAction } from 'components/button/ButtonIconAction';
import { StatusTag } from 'components/tag/StatusTag';
import { TagComponent } from 'components/tag/TagComponent';
import { Typography } from 'enable-ui';

import { RoleKey } from 'modules/auth/core/enum';
import { getStyleClassCompletion } from 'modules/classes/core/helpers';

import { ReactComponent as StarIcon } from 'assets/icons/star.svg';

import { checkRole } from 'helpers';

export const getLearnerColumns = (
  onClickAction: (key: 'edit' | 'delete' | 'update-status', id: string) => void,
) => {
  const isBiologicAdmin = checkRole([RoleKey.BIOLOGIC_ADMIN]);

  const isTrainer = checkRole([RoleKey.TRAINER_BIOLOGIC, RoleKey.TRAINER_INSTITUTION]);

  const columns: any = [
    {
      id: 'name',
      Header: 'Client',
      width: '413px',
      minWidth: isBiologicAdmin ? '33,3%' : '50%',
      sort: true,
      sortType: 'name',
      Cell: ({ ...props }) => {
        const name = props.data[props.row.index]?.name || '';

        const avatar = props.data[props.row.index]?.physicalProfile?.avatar || '';

        return <InfoComp name={name} avatar={avatar} />;
      },
    },
    {
      id: 'class',
      Header: 'Class status',
      width: isBiologicAdmin ? '33,3%' : '50%',
      minWidth: isBiologicAdmin ? '33,3%' : '50%',
      Cell: ({ ...props }) => {
        const userClass = props.data[props.row.index]?.userClass || [];

        const newCode = `0000${userClass[0]?.class?.subId || 0}`.slice(-4);

        // return (
        //   <ClassStatusComp
        //     classes={userClass.map((el: any) => ({
        //       ...el,
        //       class: {
        //         ...el.class,
        //         code: `CL-${newCode}`,
        //       },
        //     }))}
        //   />
        // );
        return (
          <Typography>
            {userClass.length} {userClass.length > 1 ? 'classes' : 'class'}
          </Typography>
        );
      },
    },
  ];

  if (isBiologicAdmin) {
    columns.push({
      id: 'institution',
      Header: 'Institution',
      width: '33,3%',
      minWidth: '33,3%',
      sort: true,
      sortType: 'institution',
      Cell: ({ ...props }) => {
        const institution = props.data[props.row.index]?.institution?.name || '';

        return <Typography>{institution}</Typography>;
      },
    });
  }

  columns.push({
    id: 'status',
    Header: 'Status',
    width: '103px',
    minWidth: '103px',
    sort: true,
    sortType: 'status',
    Cell: ({ ...props }) => {
      const isActive = props.data[props.row.index]?.isActive;

      return <StatusTag isActive={isActive} />;
    },
  });

  if (checkRole([RoleKey.INSTITUTION_ADMIN, RoleKey.BIOLOGIC_ADMIN])) {
    columns.push({
      id: 'action',
      Header: '',
      width: '40px',
      minWidth: '40px',
      sort: false,
      sortType: 'action',
      Cell: ({ ...props }) => {
        const learnerId = props.data[props.row.index]?.id;

        const isActive = props.data[props.row.index]?.isActive;

        return (
          <ButtonIconAction
            actions={[
              {
                label: 'Edit',
                onClick: () => onClickAction('edit', learnerId),
              },
              {
                label: 'Delete',
                onClick: () => onClickAction('delete', learnerId),
              },
              // isActive
              //   ? {
              //       label: 'Inactivate',
              //       onClick: () => onClickAction('update-status', learnerId),
              //     }
              //   : {
              //       label: 'Activate',
              //       onClick: () => onClickAction('update-status', learnerId),
              //     },
            ]}
          />
        );
      },
    });
  }

  return columns;
};

export const getLearnerResultColumns = () => {
  return [
    {
      id: 'name',
      Header: 'Class',
      width: '100%',
      minWidth: '100%',
      Cell: ({ ...props }) => {
        const name = props.data[props.row.index]?.class?.name || '';

        const code = props.data[props.row.index]?.class?.code;

        const thumbnail = props.data[props.row.index]?.class?.thumbnail;

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <img src={thumbnail} style={{ width: 32, height: 32, borderRadius: 8 }} />
            <div>
              <Typography style={{ fontSize: '16px', lineHeight: '22px', color: '#808080' }}>
                {code}
              </Typography>
              <Typography style={{ textAlign: 'start' }} variant="h5">
                {name}
              </Typography>
            </div>
          </div>
        );
      },
    },
    {
      id: 'score',
      Header: 'Score',
      width: '100px',
      minWidth: '100px',
      Cell: ({ ...props }) => {
        const score = props.data[props.row.index]?.totalScore ?? '0';

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <Typography>{score}</Typography>
            <StarIcon style={{ width: 18, height: 18 }} />
          </div>
        );
      },
    },
    // {
    //   id: 'rank',
    //   Header: 'Rank',
    //   width: '100px',
    //   minWidth: '100px',
    //   Cell: ({ ...props }) => {
    //     return <div></div>;
    //   },
    // },
    {
      id: 'classCompletion',
      Header: 'Class completion',
      width: '200px',
      minWidth: '200px',
      Cell: ({ ...props }) => {
        const classCompletion = props.data[props.row.index]?.class?.classCompletion;

        const { color } = getStyleClassCompletion(classCompletion);

        return <TagComponent color={color} text={classCompletion} />;
      },
    },
    {
      id: 'status',
      Header: 'Status',
      width: '100px',
      minWidth: '100px',
      Cell: ({ ...props }) => {
        const isActive = props.data[props.row.index]?.class?.isActive;

        return <StatusTag isActive={isActive} />;
      },
    },
  ];
};
